// source: observability-api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.observability_api.GetAllTelemetryRequest', null, global);
goog.exportSymbol('proto.observability_api.GetAllTelemetryResponse', null, global);
goog.exportSymbol('proto.observability_api.ObservabilityEventRecord', null, global);
goog.exportSymbol('proto.observability_api.ObservabilityLogRecord', null, global);
goog.exportSymbol('proto.observability_api.ObservabilityMetricRecord', null, global);
goog.exportSymbol('proto.observability_api.ObservabilityRecord', null, global);
goog.exportSymbol('proto.observability_api.ObservabilityRecord.RecordCase', null, global);
goog.exportSymbol('proto.observability_api.ObservabilityRecordKind', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.observability_api.GetAllTelemetryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.observability_api.GetAllTelemetryRequest.repeatedFields_, null);
};
goog.inherits(proto.observability_api.GetAllTelemetryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.observability_api.GetAllTelemetryRequest.displayName = 'proto.observability_api.GetAllTelemetryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.observability_api.ObservabilityLogRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.observability_api.ObservabilityLogRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.observability_api.ObservabilityLogRecord.displayName = 'proto.observability_api.ObservabilityLogRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.observability_api.ObservabilityEventRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.observability_api.ObservabilityEventRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.observability_api.ObservabilityEventRecord.displayName = 'proto.observability_api.ObservabilityEventRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.observability_api.ObservabilityMetricRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.observability_api.ObservabilityMetricRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.observability_api.ObservabilityMetricRecord.displayName = 'proto.observability_api.ObservabilityMetricRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.observability_api.ObservabilityRecord = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.observability_api.ObservabilityRecord.oneofGroups_);
};
goog.inherits(proto.observability_api.ObservabilityRecord, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.observability_api.ObservabilityRecord.displayName = 'proto.observability_api.ObservabilityRecord';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.observability_api.GetAllTelemetryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.observability_api.GetAllTelemetryResponse.repeatedFields_, null);
};
goog.inherits(proto.observability_api.GetAllTelemetryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.observability_api.GetAllTelemetryResponse.displayName = 'proto.observability_api.GetAllTelemetryResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.observability_api.GetAllTelemetryRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.observability_api.GetAllTelemetryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.observability_api.GetAllTelemetryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.observability_api.GetAllTelemetryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.observability_api.GetAllTelemetryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    paginate: (f = msg.getPaginate()) && common_pb.Paginate.toObject(includeInstance, f),
    criteriasList: jspb.Message.toObjectList(msg.getCriteriasList(),
    common_pb.Criteria.toObject, includeInstance),
    order: (f = msg.getOrder()) && common_pb.Ordering.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.observability_api.GetAllTelemetryRequest}
 */
proto.observability_api.GetAllTelemetryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.observability_api.GetAllTelemetryRequest;
  return proto.observability_api.GetAllTelemetryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.observability_api.GetAllTelemetryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.observability_api.GetAllTelemetryRequest}
 */
proto.observability_api.GetAllTelemetryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.Paginate;
      reader.readMessage(value,common_pb.Paginate.deserializeBinaryFromReader);
      msg.setPaginate(value);
      break;
    case 2:
      var value = new common_pb.Criteria;
      reader.readMessage(value,common_pb.Criteria.deserializeBinaryFromReader);
      msg.addCriterias(value);
      break;
    case 3:
      var value = new common_pb.Ordering;
      reader.readMessage(value,common_pb.Ordering.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.observability_api.GetAllTelemetryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.observability_api.GetAllTelemetryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.observability_api.GetAllTelemetryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.observability_api.GetAllTelemetryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaginate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.Paginate.serializeBinaryToWriter
    );
  }
  f = message.getCriteriasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      common_pb.Criteria.serializeBinaryToWriter
    );
  }
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.Ordering.serializeBinaryToWriter
    );
  }
};


/**
 * optional Paginate paginate = 1;
 * @return {?proto.Paginate}
 */
proto.observability_api.GetAllTelemetryRequest.prototype.getPaginate = function() {
  return /** @type{?proto.Paginate} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginate, 1));
};


/**
 * @param {?proto.Paginate|undefined} value
 * @return {!proto.observability_api.GetAllTelemetryRequest} returns this
*/
proto.observability_api.GetAllTelemetryRequest.prototype.setPaginate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.observability_api.GetAllTelemetryRequest} returns this
 */
proto.observability_api.GetAllTelemetryRequest.prototype.clearPaginate = function() {
  return this.setPaginate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.observability_api.GetAllTelemetryRequest.prototype.hasPaginate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Criteria criterias = 2;
 * @return {!Array<!proto.Criteria>}
 */
proto.observability_api.GetAllTelemetryRequest.prototype.getCriteriasList = function() {
  return /** @type{!Array<!proto.Criteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Criteria, 2));
};


/**
 * @param {!Array<!proto.Criteria>} value
 * @return {!proto.observability_api.GetAllTelemetryRequest} returns this
*/
proto.observability_api.GetAllTelemetryRequest.prototype.setCriteriasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Criteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Criteria}
 */
proto.observability_api.GetAllTelemetryRequest.prototype.addCriterias = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Criteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.observability_api.GetAllTelemetryRequest} returns this
 */
proto.observability_api.GetAllTelemetryRequest.prototype.clearCriteriasList = function() {
  return this.setCriteriasList([]);
};


/**
 * optional Ordering order = 3;
 * @return {?proto.Ordering}
 */
proto.observability_api.GetAllTelemetryRequest.prototype.getOrder = function() {
  return /** @type{?proto.Ordering} */ (
    jspb.Message.getWrapperField(this, common_pb.Ordering, 3));
};


/**
 * @param {?proto.Ordering|undefined} value
 * @return {!proto.observability_api.GetAllTelemetryRequest} returns this
*/
proto.observability_api.GetAllTelemetryRequest.prototype.setOrder = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.observability_api.GetAllTelemetryRequest} returns this
 */
proto.observability_api.GetAllTelemetryRequest.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.observability_api.GetAllTelemetryRequest.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.observability_api.ObservabilityLogRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.observability_api.ObservabilityLogRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.observability_api.ObservabilityLogRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.observability_api.ObservabilityLogRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    kind: jspb.Message.getFieldWithDefault(msg, 2, 0),
    level: jspb.Message.getFieldWithDefault(msg, 3, ""),
    message: jspb.Message.getFieldWithDefault(msg, 4, ""),
    projectid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    organizationid: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    scope: jspb.Message.getFieldWithDefault(msg, 7, ""),
    scopeattributesMap: (f = msg.getScopeattributesMap()) ? f.toObject(includeInstance, undefined) : [],
    attributesMap: (f = msg.getAttributesMap()) ? f.toObject(includeInstance, undefined) : [],
    occurredat: (f = msg.getOccurredat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    contextMap: (f = msg.getContextMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.observability_api.ObservabilityLogRecord}
 */
proto.observability_api.ObservabilityLogRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.observability_api.ObservabilityLogRecord;
  return proto.observability_api.ObservabilityLogRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.observability_api.ObservabilityLogRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.observability_api.ObservabilityLogRecord}
 */
proto.observability_api.ObservabilityLogRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.observability_api.ObservabilityRecordKind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLevel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setProjectid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrganizationid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setScope(value);
      break;
    case 8:
      var value = msg.getScopeattributesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 9:
      var value = msg.getAttributesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOccurredat(value);
      break;
    case 11:
      var value = msg.getContextMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.observability_api.ObservabilityLogRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.observability_api.ObservabilityLogRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.observability_api.ObservabilityLogRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.observability_api.ObservabilityLogRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLevel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProjectid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getOrganizationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      6,
      f
    );
  }
  f = message.getScope();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getScopeattributesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(8, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getAttributesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(9, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getOccurredat();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContextMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.observability_api.ObservabilityLogRecord.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityLogRecord} returns this
 */
proto.observability_api.ObservabilityLogRecord.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ObservabilityRecordKind kind = 2;
 * @return {!proto.observability_api.ObservabilityRecordKind}
 */
proto.observability_api.ObservabilityLogRecord.prototype.getKind = function() {
  return /** @type {!proto.observability_api.ObservabilityRecordKind} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.observability_api.ObservabilityRecordKind} value
 * @return {!proto.observability_api.ObservabilityLogRecord} returns this
 */
proto.observability_api.ObservabilityLogRecord.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string level = 3;
 * @return {string}
 */
proto.observability_api.ObservabilityLogRecord.prototype.getLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityLogRecord} returns this
 */
proto.observability_api.ObservabilityLogRecord.prototype.setLevel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string message = 4;
 * @return {string}
 */
proto.observability_api.ObservabilityLogRecord.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityLogRecord} returns this
 */
proto.observability_api.ObservabilityLogRecord.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint64 projectId = 5;
 * @return {string}
 */
proto.observability_api.ObservabilityLogRecord.prototype.getProjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityLogRecord} returns this
 */
proto.observability_api.ObservabilityLogRecord.prototype.setProjectid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional uint64 organizationId = 6;
 * @return {string}
 */
proto.observability_api.ObservabilityLogRecord.prototype.getOrganizationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityLogRecord} returns this
 */
proto.observability_api.ObservabilityLogRecord.prototype.setOrganizationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional string scope = 7;
 * @return {string}
 */
proto.observability_api.ObservabilityLogRecord.prototype.getScope = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityLogRecord} returns this
 */
proto.observability_api.ObservabilityLogRecord.prototype.setScope = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * map<string, string> scopeAttributes = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.observability_api.ObservabilityLogRecord.prototype.getScopeattributesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.observability_api.ObservabilityLogRecord} returns this
 */
proto.observability_api.ObservabilityLogRecord.prototype.clearScopeattributesMap = function() {
  this.getScopeattributesMap().clear();
  return this;};


/**
 * map<string, string> attributes = 9;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.observability_api.ObservabilityLogRecord.prototype.getAttributesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 9, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.observability_api.ObservabilityLogRecord} returns this
 */
proto.observability_api.ObservabilityLogRecord.prototype.clearAttributesMap = function() {
  this.getAttributesMap().clear();
  return this;};


/**
 * optional google.protobuf.Timestamp occurredAt = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.observability_api.ObservabilityLogRecord.prototype.getOccurredat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.observability_api.ObservabilityLogRecord} returns this
*/
proto.observability_api.ObservabilityLogRecord.prototype.setOccurredat = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.observability_api.ObservabilityLogRecord} returns this
 */
proto.observability_api.ObservabilityLogRecord.prototype.clearOccurredat = function() {
  return this.setOccurredat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.observability_api.ObservabilityLogRecord.prototype.hasOccurredat = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * map<string, string> context = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.observability_api.ObservabilityLogRecord.prototype.getContextMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.observability_api.ObservabilityLogRecord} returns this
 */
proto.observability_api.ObservabilityLogRecord.prototype.clearContextMap = function() {
  this.getContextMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.observability_api.ObservabilityEventRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.observability_api.ObservabilityEventRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.observability_api.ObservabilityEventRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.observability_api.ObservabilityEventRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    kind: jspb.Message.getFieldWithDefault(msg, 2, 0),
    event: jspb.Message.getFieldWithDefault(msg, 3, ""),
    component: jspb.Message.getFieldWithDefault(msg, 4, ""),
    projectid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    organizationid: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    scope: jspb.Message.getFieldWithDefault(msg, 7, ""),
    scopeattributesMap: (f = msg.getScopeattributesMap()) ? f.toObject(includeInstance, undefined) : [],
    attributesMap: (f = msg.getAttributesMap()) ? f.toObject(includeInstance, undefined) : [],
    occurredat: (f = msg.getOccurredat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    contextMap: (f = msg.getContextMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.observability_api.ObservabilityEventRecord}
 */
proto.observability_api.ObservabilityEventRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.observability_api.ObservabilityEventRecord;
  return proto.observability_api.ObservabilityEventRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.observability_api.ObservabilityEventRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.observability_api.ObservabilityEventRecord}
 */
proto.observability_api.ObservabilityEventRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.observability_api.ObservabilityRecordKind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setComponent(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setProjectid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrganizationid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setScope(value);
      break;
    case 8:
      var value = msg.getScopeattributesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 9:
      var value = msg.getAttributesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOccurredat(value);
      break;
    case 11:
      var value = msg.getContextMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.observability_api.ObservabilityEventRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.observability_api.ObservabilityEventRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.observability_api.ObservabilityEventRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.observability_api.ObservabilityEventRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEvent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getComponent();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProjectid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getOrganizationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      6,
      f
    );
  }
  f = message.getScope();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getScopeattributesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(8, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getAttributesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(9, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getOccurredat();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContextMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.observability_api.ObservabilityEventRecord.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityEventRecord} returns this
 */
proto.observability_api.ObservabilityEventRecord.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ObservabilityRecordKind kind = 2;
 * @return {!proto.observability_api.ObservabilityRecordKind}
 */
proto.observability_api.ObservabilityEventRecord.prototype.getKind = function() {
  return /** @type {!proto.observability_api.ObservabilityRecordKind} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.observability_api.ObservabilityRecordKind} value
 * @return {!proto.observability_api.ObservabilityEventRecord} returns this
 */
proto.observability_api.ObservabilityEventRecord.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string event = 3;
 * @return {string}
 */
proto.observability_api.ObservabilityEventRecord.prototype.getEvent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityEventRecord} returns this
 */
proto.observability_api.ObservabilityEventRecord.prototype.setEvent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string component = 4;
 * @return {string}
 */
proto.observability_api.ObservabilityEventRecord.prototype.getComponent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityEventRecord} returns this
 */
proto.observability_api.ObservabilityEventRecord.prototype.setComponent = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint64 projectId = 5;
 * @return {string}
 */
proto.observability_api.ObservabilityEventRecord.prototype.getProjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityEventRecord} returns this
 */
proto.observability_api.ObservabilityEventRecord.prototype.setProjectid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional uint64 organizationId = 6;
 * @return {string}
 */
proto.observability_api.ObservabilityEventRecord.prototype.getOrganizationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityEventRecord} returns this
 */
proto.observability_api.ObservabilityEventRecord.prototype.setOrganizationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional string scope = 7;
 * @return {string}
 */
proto.observability_api.ObservabilityEventRecord.prototype.getScope = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityEventRecord} returns this
 */
proto.observability_api.ObservabilityEventRecord.prototype.setScope = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * map<string, string> scopeAttributes = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.observability_api.ObservabilityEventRecord.prototype.getScopeattributesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.observability_api.ObservabilityEventRecord} returns this
 */
proto.observability_api.ObservabilityEventRecord.prototype.clearScopeattributesMap = function() {
  this.getScopeattributesMap().clear();
  return this;};


/**
 * map<string, string> attributes = 9;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.observability_api.ObservabilityEventRecord.prototype.getAttributesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 9, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.observability_api.ObservabilityEventRecord} returns this
 */
proto.observability_api.ObservabilityEventRecord.prototype.clearAttributesMap = function() {
  this.getAttributesMap().clear();
  return this;};


/**
 * optional google.protobuf.Timestamp occurredAt = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.observability_api.ObservabilityEventRecord.prototype.getOccurredat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.observability_api.ObservabilityEventRecord} returns this
*/
proto.observability_api.ObservabilityEventRecord.prototype.setOccurredat = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.observability_api.ObservabilityEventRecord} returns this
 */
proto.observability_api.ObservabilityEventRecord.prototype.clearOccurredat = function() {
  return this.setOccurredat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.observability_api.ObservabilityEventRecord.prototype.hasOccurredat = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * map<string, string> context = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.observability_api.ObservabilityEventRecord.prototype.getContextMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.observability_api.ObservabilityEventRecord} returns this
 */
proto.observability_api.ObservabilityEventRecord.prototype.clearContextMap = function() {
  this.getContextMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.observability_api.ObservabilityMetricRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.observability_api.ObservabilityMetricRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.observability_api.ObservabilityMetricRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    kind: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    value: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, ""),
    projectid: jspb.Message.getFieldWithDefault(msg, 6, "0"),
    organizationid: jspb.Message.getFieldWithDefault(msg, 7, "0"),
    scope: jspb.Message.getFieldWithDefault(msg, 8, ""),
    scopeattributesMap: (f = msg.getScopeattributesMap()) ? f.toObject(includeInstance, undefined) : [],
    attributesMap: (f = msg.getAttributesMap()) ? f.toObject(includeInstance, undefined) : [],
    occurredat: (f = msg.getOccurredat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    contextMap: (f = msg.getContextMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.observability_api.ObservabilityMetricRecord}
 */
proto.observability_api.ObservabilityMetricRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.observability_api.ObservabilityMetricRecord;
  return proto.observability_api.ObservabilityMetricRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.observability_api.ObservabilityMetricRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.observability_api.ObservabilityMetricRecord}
 */
proto.observability_api.ObservabilityMetricRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.observability_api.ObservabilityRecordKind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setProjectid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOrganizationid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setScope(value);
      break;
    case 9:
      var value = msg.getScopeattributesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 10:
      var value = msg.getAttributesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOccurredat(value);
      break;
    case 12:
      var value = msg.getContextMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.observability_api.ObservabilityMetricRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.observability_api.ObservabilityMetricRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.observability_api.ObservabilityMetricRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProjectid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      6,
      f
    );
  }
  f = message.getOrganizationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      7,
      f
    );
  }
  f = message.getScope();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getScopeattributesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(9, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getAttributesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getOccurredat();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContextMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(12, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
 */
proto.observability_api.ObservabilityMetricRecord.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ObservabilityRecordKind kind = 2;
 * @return {!proto.observability_api.ObservabilityRecordKind}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.getKind = function() {
  return /** @type {!proto.observability_api.ObservabilityRecordKind} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.observability_api.ObservabilityRecordKind} value
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
 */
proto.observability_api.ObservabilityMetricRecord.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
 */
proto.observability_api.ObservabilityMetricRecord.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string value = 4;
 * @return {string}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
 */
proto.observability_api.ObservabilityMetricRecord.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
 */
proto.observability_api.ObservabilityMetricRecord.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint64 projectId = 6;
 * @return {string}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.getProjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, "0"));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
 */
proto.observability_api.ObservabilityMetricRecord.prototype.setProjectid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 6, value);
};


/**
 * optional uint64 organizationId = 7;
 * @return {string}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.getOrganizationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, "0"));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
 */
proto.observability_api.ObservabilityMetricRecord.prototype.setOrganizationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 7, value);
};


/**
 * optional string scope = 8;
 * @return {string}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.getScope = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
 */
proto.observability_api.ObservabilityMetricRecord.prototype.setScope = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * map<string, string> scopeAttributes = 9;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.getScopeattributesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 9, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
 */
proto.observability_api.ObservabilityMetricRecord.prototype.clearScopeattributesMap = function() {
  this.getScopeattributesMap().clear();
  return this;};


/**
 * map<string, string> attributes = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.getAttributesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
 */
proto.observability_api.ObservabilityMetricRecord.prototype.clearAttributesMap = function() {
  this.getAttributesMap().clear();
  return this;};


/**
 * optional google.protobuf.Timestamp occurredAt = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.getOccurredat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
*/
proto.observability_api.ObservabilityMetricRecord.prototype.setOccurredat = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
 */
proto.observability_api.ObservabilityMetricRecord.prototype.clearOccurredat = function() {
  return this.setOccurredat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.hasOccurredat = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * map<string, string> context = 12;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.observability_api.ObservabilityMetricRecord.prototype.getContextMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 12, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.observability_api.ObservabilityMetricRecord} returns this
 */
proto.observability_api.ObservabilityMetricRecord.prototype.clearContextMap = function() {
  this.getContextMap().clear();
  return this;};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.observability_api.ObservabilityRecord.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.observability_api.ObservabilityRecord.RecordCase = {
  RECORD_NOT_SET: 0,
  LOG: 1,
  EVENT: 2,
  METRIC: 3
};

/**
 * @return {proto.observability_api.ObservabilityRecord.RecordCase}
 */
proto.observability_api.ObservabilityRecord.prototype.getRecordCase = function() {
  return /** @type {proto.observability_api.ObservabilityRecord.RecordCase} */(jspb.Message.computeOneofCase(this, proto.observability_api.ObservabilityRecord.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.observability_api.ObservabilityRecord.prototype.toObject = function(opt_includeInstance) {
  return proto.observability_api.ObservabilityRecord.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.observability_api.ObservabilityRecord} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.observability_api.ObservabilityRecord.toObject = function(includeInstance, msg) {
  var f, obj = {
    log: (f = msg.getLog()) && proto.observability_api.ObservabilityLogRecord.toObject(includeInstance, f),
    event: (f = msg.getEvent()) && proto.observability_api.ObservabilityEventRecord.toObject(includeInstance, f),
    metric: (f = msg.getMetric()) && proto.observability_api.ObservabilityMetricRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.observability_api.ObservabilityRecord}
 */
proto.observability_api.ObservabilityRecord.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.observability_api.ObservabilityRecord;
  return proto.observability_api.ObservabilityRecord.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.observability_api.ObservabilityRecord} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.observability_api.ObservabilityRecord}
 */
proto.observability_api.ObservabilityRecord.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.observability_api.ObservabilityLogRecord;
      reader.readMessage(value,proto.observability_api.ObservabilityLogRecord.deserializeBinaryFromReader);
      msg.setLog(value);
      break;
    case 2:
      var value = new proto.observability_api.ObservabilityEventRecord;
      reader.readMessage(value,proto.observability_api.ObservabilityEventRecord.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    case 3:
      var value = new proto.observability_api.ObservabilityMetricRecord;
      reader.readMessage(value,proto.observability_api.ObservabilityMetricRecord.deserializeBinaryFromReader);
      msg.setMetric(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.observability_api.ObservabilityRecord.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.observability_api.ObservabilityRecord.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.observability_api.ObservabilityRecord} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.observability_api.ObservabilityRecord.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLog();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.observability_api.ObservabilityLogRecord.serializeBinaryToWriter
    );
  }
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.observability_api.ObservabilityEventRecord.serializeBinaryToWriter
    );
  }
  f = message.getMetric();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.observability_api.ObservabilityMetricRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional ObservabilityLogRecord log = 1;
 * @return {?proto.observability_api.ObservabilityLogRecord}
 */
proto.observability_api.ObservabilityRecord.prototype.getLog = function() {
  return /** @type{?proto.observability_api.ObservabilityLogRecord} */ (
    jspb.Message.getWrapperField(this, proto.observability_api.ObservabilityLogRecord, 1));
};


/**
 * @param {?proto.observability_api.ObservabilityLogRecord|undefined} value
 * @return {!proto.observability_api.ObservabilityRecord} returns this
*/
proto.observability_api.ObservabilityRecord.prototype.setLog = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.observability_api.ObservabilityRecord.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.observability_api.ObservabilityRecord} returns this
 */
proto.observability_api.ObservabilityRecord.prototype.clearLog = function() {
  return this.setLog(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.observability_api.ObservabilityRecord.prototype.hasLog = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ObservabilityEventRecord event = 2;
 * @return {?proto.observability_api.ObservabilityEventRecord}
 */
proto.observability_api.ObservabilityRecord.prototype.getEvent = function() {
  return /** @type{?proto.observability_api.ObservabilityEventRecord} */ (
    jspb.Message.getWrapperField(this, proto.observability_api.ObservabilityEventRecord, 2));
};


/**
 * @param {?proto.observability_api.ObservabilityEventRecord|undefined} value
 * @return {!proto.observability_api.ObservabilityRecord} returns this
*/
proto.observability_api.ObservabilityRecord.prototype.setEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.observability_api.ObservabilityRecord.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.observability_api.ObservabilityRecord} returns this
 */
proto.observability_api.ObservabilityRecord.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.observability_api.ObservabilityRecord.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ObservabilityMetricRecord metric = 3;
 * @return {?proto.observability_api.ObservabilityMetricRecord}
 */
proto.observability_api.ObservabilityRecord.prototype.getMetric = function() {
  return /** @type{?proto.observability_api.ObservabilityMetricRecord} */ (
    jspb.Message.getWrapperField(this, proto.observability_api.ObservabilityMetricRecord, 3));
};


/**
 * @param {?proto.observability_api.ObservabilityMetricRecord|undefined} value
 * @return {!proto.observability_api.ObservabilityRecord} returns this
*/
proto.observability_api.ObservabilityRecord.prototype.setMetric = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.observability_api.ObservabilityRecord.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.observability_api.ObservabilityRecord} returns this
 */
proto.observability_api.ObservabilityRecord.prototype.clearMetric = function() {
  return this.setMetric(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.observability_api.ObservabilityRecord.prototype.hasMetric = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.observability_api.GetAllTelemetryResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.observability_api.GetAllTelemetryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.observability_api.GetAllTelemetryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.observability_api.GetAllTelemetryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.observability_api.GetAllTelemetryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.observability_api.ObservabilityRecord.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.observability_api.GetAllTelemetryResponse}
 */
proto.observability_api.GetAllTelemetryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.observability_api.GetAllTelemetryResponse;
  return proto.observability_api.GetAllTelemetryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.observability_api.GetAllTelemetryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.observability_api.GetAllTelemetryResponse}
 */
proto.observability_api.GetAllTelemetryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.observability_api.ObservabilityRecord;
      reader.readMessage(value,proto.observability_api.ObservabilityRecord.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.observability_api.GetAllTelemetryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.observability_api.GetAllTelemetryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.observability_api.GetAllTelemetryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.observability_api.GetAllTelemetryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.observability_api.ObservabilityRecord.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.observability_api.GetAllTelemetryResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.observability_api.GetAllTelemetryResponse} returns this
 */
proto.observability_api.GetAllTelemetryResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.observability_api.GetAllTelemetryResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.observability_api.GetAllTelemetryResponse} returns this
 */
proto.observability_api.GetAllTelemetryResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated ObservabilityRecord data = 3;
 * @return {!Array<!proto.observability_api.ObservabilityRecord>}
 */
proto.observability_api.GetAllTelemetryResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.observability_api.ObservabilityRecord>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.observability_api.ObservabilityRecord, 3));
};


/**
 * @param {!Array<!proto.observability_api.ObservabilityRecord>} value
 * @return {!proto.observability_api.GetAllTelemetryResponse} returns this
*/
proto.observability_api.GetAllTelemetryResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.observability_api.ObservabilityRecord=} opt_value
 * @param {number=} opt_index
 * @return {!proto.observability_api.ObservabilityRecord}
 */
proto.observability_api.GetAllTelemetryResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.observability_api.ObservabilityRecord, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.observability_api.GetAllTelemetryResponse} returns this
 */
proto.observability_api.GetAllTelemetryResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.observability_api.GetAllTelemetryResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.observability_api.GetAllTelemetryResponse} returns this
*/
proto.observability_api.GetAllTelemetryResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.observability_api.GetAllTelemetryResponse} returns this
 */
proto.observability_api.GetAllTelemetryResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.observability_api.GetAllTelemetryResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.observability_api.GetAllTelemetryResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.observability_api.GetAllTelemetryResponse} returns this
*/
proto.observability_api.GetAllTelemetryResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.observability_api.GetAllTelemetryResponse} returns this
 */
proto.observability_api.GetAllTelemetryResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.observability_api.GetAllTelemetryResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * @enum {number}
 */
proto.observability_api.ObservabilityRecordKind = {
  OBSERVABILITY_RECORD_KIND_UNSPECIFIED: 0,
  OBSERVABILITY_RECORD_KIND_LOG: 1,
  OBSERVABILITY_RECORD_KIND_EVENT: 2,
  OBSERVABILITY_RECORD_KIND_METRIC: 3
};

goog.object.extend(exports, proto.observability_api);
